import { createToaster } from 'sonner-vanilla';
import '../../../styles/account.pcss';
import '../modal/modal';
import { initActivities } from './activities';
import { initAppointments } from './appointments';
import { initBooking } from './booking';
import { initPasswordChange } from './password';
import { initProfile } from './profile';

createToaster({
	position: 'bottom-right',
	theme: 'light',
	richColors: true,
	closeButton: true,
}).mount(document.body);

document.addEventListener('DOMContentLoaded', () => {
	initActivities();
	initAppointments();
	initBooking();
	initPasswordChange();
	initProfile();
});
